import { render, staticRenderFns } from "./divider-primary.vue?vue&type=template&id=1dbabe32&scoped=true&"
import script from "./divider-primary.vue?vue&type=script&lang=js&"
export * from "./divider-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbabe32",
  null
  
)

export default component.exports